import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Account } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { getAccountKey } from '~/swr-hooks/account/useAccount';

export type UsePrivateAccountRequestEmailChangeMutationParams = NonNullable<
  Parameters<typeof Account.requestEmailChange>[0]
>;

export const usePrivateAccountRequestEmailChangeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateAccountRequestEmailChangeMutationParams) => {
      return callAirApi(() => Account.requestEmailChange(params));
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getAccountKey() });
    },
  });
};
